import { useCallback, useState } from 'react';
import { errorKey } from '../api/client';

/** Holds the i18n key of the last server error for a form, and clears it on retry. */
export function useFormError() {
  const [key, setKey] = useState<string | null>(null);

  return {
    errorKey: key,
    clear: useCallback(() => setKey(null), []),
    capture: useCallback((error: unknown) => setKey(errorKey(error)), []),
  };
}
